module.exports = __webpack_public_path__ + "media/native-apps/norrbottenslan-44f50929.webp";